import React from 'react'
import { useLocation } from 'react-router-dom'
import KarteraAdminTemplate from '../template/KarteraAdminTemplate'
import KarteraPageHeader from '../template/kartera/KarteraPageHeader'
import { flattenNavigation, navigation } from '../template/navigation'

const ComingSoon = ({ title }) => {
    const { pathname } = useLocation()
    const match = flattenNavigation(navigation).find((item) => pathname === item.to || pathname.startsWith(`${item.to}/`))
    const heading = title || match?.label || 'Módulo'

    return (
        <KarteraAdminTemplate title={heading}>
            <KarteraPageHeader
                title={heading}
                description="Este módulo se está migrando a Kartera 365. El acceso ya respeta los roles de tu usuario."
            />
            <section className="k-card max-w-[640px]">
                <p className="m-0 text-sm text-k-ink-2">
                    La navegación y los permisos ya están conectados al API de Dalala. Cuando el módulo esté listo, aparecerá aquí sin cambiar de sesión.
                </p>
            </section>
        </KarteraAdminTemplate>
    )
}

export default ComingSoon
